import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';
import { Keys } from '@oracle/oraclejet-testing/UNSAFE_Driver';
import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';

export class InputPasswordAdapter extends TestAdapter {
  /**
   * Clear and commit the value of the input element
   * @returns Promise<void>
   */
  async clear() {
    await this.changeValue(undefined);
  }

  /**
   * Change and commit the value of the input element
   * @param value {string | undefined} The new value
   * @returns Promise<void>
   */
  async changeValue(value: string | undefined) {
    const driver = this.getTestDriver();
    // Find the <input> element underneath the root.
    const el = await this.getElement();
    const input = await el.waitForElement(byCss('input'));

    // Select all, then delete to clear any value.
    await driver.sendKeys(input, Keys['CONTROL_COMMAND'], 'a');
    await driver.sendKeys(input, Keys['DELETE']);

    if (value !== undefined) {
      await driver.sendKeys(input, value);
    }

    // Commit
    await driver.sendKeys(input, Keys['ENTER']);
  }
}
